<!--
* UIID:
* UI Name: Add Message Code
* Modify Date: 2020/12/21
-->
<template>
  <dialog-drag
    :id="id"
    :ref='"dialog-" + id'
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title
        class="headline white--text"
        primary-title>
          {{ `${options.item.isEdit ? 'Modify' : 'Add'} Message Code` }}
      </v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="v-dialog-1">

      <!-- [S]  Popup body-->
      <system-progress
        :sysloading="isLoading"
      ></system-progress>
      <v-card-text class="pa-0">
        <v-form ref="form" class="dialog-content form-msgcd">
          <v-row class="ml-0 mr-0  mb-1">
            <v-col cols="12" class="pa-0">
              <v-label><v-icon v-if="indexType === -1" x-small class="mr-1">fa fa-asterisk</v-icon>Message Code</v-label>
              <!-- /**
               * 2021.07.14 203737 SPKA-154 issue 102  Change "Message Code" field from combo box to text field in the "Add Message Code" popup
               */ -->
              <!-- <v-autocomplete v-if="indexType === -1"
                solo
                v-model="msg_cd"
                :items="EDIMesList"
                :rules="[validationUtils.required]"
              ></v-autocomplete> -->
              <v-text-field v-if="indexType === -1"
                v-model="msg_cd"
                :rules="[validationUtils.required, validationUtils.max(100)]"
                solo
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0 mb-1">
            <v-col cols="12" class="pa-0">
              <v-label><v-icon v-if="indexType == -1" x-small class="mr-1">fa fa-asterisk</v-icon>Message Name</v-label>
              <v-text-field v-if="indexType == -1"
                v-model="msg_nm"
                :rules="[validationUtils.required, validationUtils.max(100)]"
                solo
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
             <v-col cols="12" class="pa-0">
                <v-label>Message Description</v-label>
                <v-textarea
                  v-model="msg_desc"
                  counter="200"
                  solo
                  height="60"
                  :rules="[validationUtils.max(200)]"
                  :disabled="!$auth.manage"
                ></v-textarea>
              </v-col>
          </v-row>
        </v-form>
        <!-- [E]  Popup body-->
        <!-- [S]  Button Group-->
        <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
        <v-row class="ml-0 mr-0">
          <v-col class="button-col action-col" lg="12">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-popup btn-delete" @click="removeDialog">
                <!-- <v-icon small color="white" class="mr-1">fa fa-times</v-icon> -->
                {{$t('btn.common.close')}}
              </v-btn>
              <v-btn class="btn btn-popup btn-popup-search" color="primary" @click="onSave">
                <!-- <v-icon x-small class="mr-2">fas fa-save</v-icon> -->
                {{$t('btn.common.save')}}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Button Group-->
      <dialogWindow
        ref="srchKeyDialog"
        size="max"
        :info="checkDialogTitle"
        :detail="checkDialogInfo"
        :color="checkDialogColor"
        @select-ok="removeDialog({})"
      >
      </dialogWindow>
    </v-card>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag2.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'
import { mapState } from "vuex";
import IconSvg from "@/vue-caas/components/IconBase.vue";
import SystemProgress from "@/vue-dlb/components/SystemProgress.vue";

export default {
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
    SystemProgress,
  },
  name: 'add-msgcd-dialog',
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd', "indexType", "refeshList", "paramItem"],
  props:{
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    indexType: Number,
    refeshList: Function,
    paramItem:Object
  },
  computed: {
      ...mapState("common", {
        CommMsgList: "CommMsgList",
      }),
    },
  data(){
    return{
    msg_cd: '',
    msg_nm: '',
    msg_desc: '',
    checkDialogColor: 'warning',
    checkDialogTitle: '',
    checkDialogInfo: '',
    /**
     * 2021.07.14 203737 SPKA-154 issue 102  Change "Message Code" field from combo box to text field in the "Add Message Code" popup
     */
    // EDIMesList: [
    //   {text:'Select Message Code', value:''}
    // ],
    addDataItems:[
      {
        header: ['MSG_CD','MSG_NM','MSG_DESC'],
        data: [],
      }
    ],
    isLoading: false,
  }},

  methods: {
    removeDialog (dialog) {
      if (this.$refs.srchKeyDialog.dialog && this.checkDialogColor === 'error') {
        this.$refs.srchKeyDialog.dialog = false;
      } else {
        dialog.id = this.id;
        this.closeDialog(dialog);
        if (dialog && dialog.reload) {
          this.$emit('search');
        }
      }
    },
    selectDialog (obj) {
      this.dragStart(obj);
    },
    dialogDragEnd (obj) {
      this.dragEnd(obj);
    },
    onSave() {
      this.isLoading = true;
      let validResult = this.$refs.form.validate();
      if(validResult){
        //const params = {};

        // params.usr_id = this.$cookies.get('user-id');
        // params.msg_cd = this.msg_cd;
        // params.msg_desc = this.msg_desc;
        // params.srch_key_item = this.srch_key_item;
        this.addDataItems[0].data[0] = {
            MSG_CD: this.msg_cd,
            MSG_NM: this.msg_nm,
            MSG_DESC: this.msg_desc,
        };
        this.$store.dispatch('insertMessageCode', this.addDataItems).then(() => {
          this.refeshList();
          this.$refs.srchKeyDialog.dialog = true;
          this.checkDialogColor = 'success';
          this.checkDialogInfo = this.$t('msg.codes.saveAddMsgCd');
        });
      }
      this.isLoading = false;
      return validResult;
    },
    getEDIMsgTypeList(){
        let commMsgSearchItems = {
          header: ['MSG_NM'],
          data: [{
            MSG_NM:''
          }]
        };
        this.$store.dispatch("common/getCommonMessageList", commMsgSearchItems).then(() => {
            console.log("--------- Finished to process MES ----------");
            for(let i=0;i< this.CommMsgList.length;i++){
              let EDIVerObj= {};
              EDIVerObj.text= this.CommMsgList[i].MSG_CD+" ("+ this.CommMsgList[i].MSG_NM+")";
              EDIVerObj.value= this.CommMsgList[i].MSG_CD;
              /**
               * 2021.07.14 203737 SPKA-154 issue 102  Change "Message Code" field from combo box to text field in the "Add Message Code" popup
               */
              // this.EDIMesList.push(EDIVerObj);
            }
        });
      },
  },
  created() {
    this.getEDIMsgTypeList();
  },

  mounted() {
    // setTimeout(() => {
    //   this.$refs.msg_cd.focus();
    // }, 300);
  },
}
</script>
<style>
.v-dialog-1 .form-msgcd textarea{
	margin-top: 0px !important;
	max-height: 60px;
	min-height: 60px;
	font-size: 14px !important;
  font-weight: bold;
}
.form-msgcd .v-text-field{
	margin-top: 5px;
}
.form-msgcd input, .form-msgcd .v-select__selections{
	max-height: 30px !important;
}
.theme--light .v-dialog-1 .form-msgcd textarea{
	color: #000000;
}
.theme--dark .v-dialog-1 .form-msgcd textarea{
	color: #bbbbbb;
}
.theme--dark .form-msgcd .v-select .v-select__selection--comma{
	color: #bbbbbb;
	font-size: 14px !important;
  font-weight: bold;
}
</style>